module.exports = __webpack_public_path__ + "media/images/new/icons/document-8dd0193fcf8998fce178372484c80de4.png";